module.exports = __webpack_public_path__ + "media/src/images/icons/chevron-back-62b6fc7c1f216bc27649c125515aa31b.svg";